// extracted by mini-css-extract-plugin
export default {"header":"Header-module__header__tlVPCer","content":"Header-module__content__xAeggz2","heading":"Header-module__heading__ndCk0WD","subheading":"Header-module__subheading__cQUIoQ0"};